export const pushNotificationOptions = [
  { name: 'Nuolaidų pasiūlymai', value: 140 },
  { name: 'Sugeneruota sąskaita-faktūra', value: 141 },
  { name: 'Palikta įjungta plovykla', value: 142 },
];

export const emailOptions = [
  { name: 'Sugeneruota sąskaita-faktūra', value: 151 },
  { name: 'Nuolaidų pasiūlymai', value: 150 },
];

export const smsOptions = [
  { name: 'Sugeneruota sąskaita-faktūra', value: 161 },
  { name: 'Nuolaidų pasiūlymai', value: 160 },
];
